<template>
	<div>
		<v-row v-if="visitsPerson.length">
			<v-col cols="12" class="mt-2 overflow-y-auto overflow-x-auto work-history">
				<h3 class="accent--text text-left">Solicitudes de agendamiento</h3>

				<v-data-table
					mobile-breakpoint="0"
					:items-per-page="5"
					:items="visitsPerson"
					:headers="headers"
					no-data-text="No hay personas excluidas"
					:footer-props="{
						'items-per-page-text': 'Personas por página',
					}"
				>
					<template v-slot:[`item.date`]="{ item }">
						{{
							isArray(item.visit.dates[0])
								? `${item.visit.dates[0][0]} / ${item.visit.dates[0][1]}`
								: item.visit.dates[0]
						}}
					</template>
					<template v-slot:[`item.person`]="{ item }">
						{{ item.person.firstName }} {{ item.person.lastName }}
					</template>
					<template v-slot:[`item.place`]="{ item }">
						{{ getPlace(item.visit.place) }}
					</template>
					<template v-slot:[`item.etiqueta`]="{ item }">
						{{ item.visit.room }}
					</template>
					<template v-slot:[`item.period`]="{ item }">
						{{ item.visit.group }}
					</template>
					<template v-slot:[`item.action`]="{ item }">
						<v-btn
							color="info"
							depressed
							x-small
							class="row-td-block text-capitalize"
							@click="
								setLodgingForm({
									visit: item.visit,
									person: item.person,
								})
							"
						>
							Rellenar
						</v-btn>
						<v-btn
							color="error"
							depressed
							x-small
							class="ml-1 row-td-block text-capitalize"
							@click="deleteVisit(k, item.person)"
						>
							<v-icon small>mdi-delete</v-icon>
						</v-btn>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
		<data-empty
			v-else
			:title="`Sin visitas recomendadas`"
			:msj="`No existen nuevas recomendaciones de visitas`"
		/>
	</div>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapMutations, mapActions } from 'vuex';
export default {
	name: 'ListWorkerVisit',
	components: {
		DataEmpty: () => import('@/components/ui/DataEmpty'),
	},
	data() {
		return {
			menuOT: false,
			month: moment()
				.date(1)
				.format('YYYY-MM'),
			dialog: false,
			certificateValues: { lodId: '', type: '', index: 0, ot: null },
			filter1: '',
			filter2: '',
			headers: [
				{ text: 'Fecha', value: 'date', sortable: true },
				{ text: 'Persona', value: 'person', sortable: false },
				{ text: 'Lugar', value: 'place', sortable: false },
				{ text: 'Etiqueta', value: 'etiqueta', sortable: false },
				{ text: 'Periodo', value: 'period', sortable: false },
				{ text: 'Acciones', value: 'action', sortable: false },
			],
		};
	},
	computed: {
		dateFormatted() {
			return this.month ? moment(this.month).format('MMMM YYYY') : '';
		},
		visitsPerson() {
			let visits = [];
			this.listPerson.forEach(person => {
				if (person.requestActivity?.length > 0) {
					person.requestActivity.forEach(visit => {
						visits.push({ visit, person });
					});
				}
			});
			const a = visits.sort((a, b) => {
				const dateB = this.isArray(b.visit.dates[0])
					? moment(b.visit.dates[0][0], 'YYYY-MM-DD')
					: moment(b.visit.dates[0], 'YYYY-MM-DD');
				const dateA = this.isArray(a.visit.dates[0])
					? moment(a.visit.dates[0][0], 'YYYY-MM-DD')
					: moment(a.visit.dates[0], 'YYYY-MM-DD');
				return dateB - dateA;
			});
			return a;
		},
		...mapGetters({
			places: 'Place/places',
			listPerson: 'Person/persons',
		}),
	},
	methods: {
		isArray(array) {
			return Array.isArray(array);
		},
		getPerson(id) {
			return this.listPerson.find(person => person._id == id);
		},
		getPlace(id) {
			const place = this.places.find(place => place._id == id);
			return place ? place.name : '';
		},
		async deleteVisit(index, person) {
			await this.deleteWorkerVisit({ index, person: person._id });
		},
		...mapMutations({
			setLodgingForm: 'Lodging/setLodgingForm',
		}),
		...mapActions({
			deleteWorkerVisit: 'Lodging/deleteWorkerVisit',
		}),
	},
};
</script>
<style lang="scss"></style>
